// pdfjs-dist uses Promise.try, which is not available in some supported browsers.
const promiseConstructor = Promise as PromiseConstructor & {
  try?: <T>(callback: (...args: any[]) => T, ...args: any[]) => Promise<T>;
};

if (typeof promiseConstructor.try !== 'function') {
  promiseConstructor.try = <T>(callback: (...args: any[]) => T, ...args: any[]) =>
    new Promise<T>((resolve) => resolve(callback(...args)));
}
